import { DOCUMENT_TYPE_SUB_TYPES } from "@/constants";

const NO_SUB_TYPES = [];

export function getDocumentSubTypes(docType) {
  return DOCUMENT_TYPE_SUB_TYPES[docType] ?? NO_SUB_TYPES;
}

export function getDocumentSubType(docType, documentSubType) {
  return getDocumentSubTypes(docType).find(subType => subType === documentSubType) ?? null;
}
